import * as model from './models';

import createAxios from '@framework/http';
const axios = createAxios({ keys: 'userInfo.shopId', DEBUG: process.env.KS_ENV !== 'prod' });

/** 分销者  查询分销者信息 */
export async function detailUsingPOST() {
    const result = await axios.post<model.IMessageDistributorVo>(`/rest/op/vc/distribution/distributor/detail`);
    return result;
}
